module.exports = __webpack_public_path__ + "img/restyling.e677b296.png";